module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_60.ec6752dc.mp3";